import client from "./client";

// روابط طباعة المستندات الرسمية (JWT صالح 24 ساعة) — القاعدة الذهبية للتصميم.
export const issuePrintLink = async (kind, docId) =>
  (await client.post(`/v1/docs/${kind}/${docId}/print-link`)).data;

export const printUrl = (link) => `${process.env.REACT_APP_BACKEND_URL}${link.url}`;

export const openOfficialDoc = async (kind, docId, copy = "") => {
  const link = await issuePrintLink(kind, docId);
  window.open(printUrl(link) + (copy ? `&copy=${copy}` : ""), "_blank", "noopener");
};
